import trainingApi from './trainingApi';
import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const trainingAuthService = {
  checkEmployee: async (empCode) => {
    try {
      const response = await axios.post(`${BASE}/api/training-auth/check-employee`, { emp_code: empCode });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to check employee' };
    }
  },

  register: async (userData) => {
    try {
      const response = await axios.post(`${BASE}/api/training-auth/register`, userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Registration failed' };
    }
  },

  verifyEmail: async (email, verificationCode) => {
    try {
      const response = await axios.post(`${BASE}/api/training-auth/verify-email`, {
        email,
        verification_code: verificationCode,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Verification failed' };
    }
  },

  resendVerification: async (email) => {
    try {
      const response = await axios.post(`${BASE}/api/training-auth/resend-verification`, { email });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to resend verification code' };
    }
  },

  login: async (email, password, role) => {
    try {
      const response = await axios.post(`${BASE}/api/training-auth/login`, { email, password, role });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Login failed' };
    }
  },

  getProfile: async () => {
    try {
      const response = await trainingApi.get('/api/training-auth/profile');
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to get profile' };
    }
  },

  updateProfile: async (fullName) => {
    try {
      const response = await trainingApi.put('/api/training-auth/profile', { full_name: fullName });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to update profile' };
    }
  },

  changePassword: async (oldPassword, newPassword) => {
    try {
      const response = await trainingApi.post('/api/training-auth/change-password', {
        old_password: oldPassword,
        new_password: newPassword,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to change password' };
    }
  },
};

export default trainingAuthService;
